module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 45300.cac8101e.png";